import { useMemo } from 'react'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { StyledEngineProvider } from '@mui/material'
import type { ThemeProviderProps } from './ThemeProvider.types'
import blogTheme from '../../tokens/blog/index'
import BaseStyles from '../BaseStyles/index'

const ThemeProvider = ({ theme = blogTheme, children, ...props }: ThemeProviderProps) => {
  const mergedTheme = useMemo(() => createTheme(undefined, theme), [theme])
  return (
    <MuiThemeProvider {...props} theme={mergedTheme}>
      <StyledEngineProvider injectFirst>
        <BaseStyles />
        {children}
      </StyledEngineProvider>
    </MuiThemeProvider>
  )
}

export default ThemeProvider
